import { Body, Box } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

interface Props {
  visible: boolean;
}

const ThirdTeamValue: React.FC<Props> = ({ visible }) => (
  <Box
    display={visible ? 'block' : 'none'}
    width={{ base: '100%', desktop: 584 }}
  >
    <StaticImage
      quality={100}
      placeholder="blurred"
      src="../../../assets/images/our_values_3.png"
      alt="our values 1"
    />
    <Body mt={600} mb={{ desktop: 900 }} size={500} maxW="584px">
      We are all about empowering others through service, because we believe
      that with service, trust and collaboration, anything is possible.
    </Body>
  </Box>
);

export default ThirdTeamValue;
